export default defineNuxtRouteMiddleware((to, from) => {
	if (process.server) return;

	if (process.client) {
		window.dataLayer?.push({ event: 'navigated', route: to.name });
	}
})
